export default async (props) => {
  const { app } = props;

  app.router.push = function (location, onComplete, onAbort) {
    const current = app.router.history.current
    const route = app.router.match(location, current)

    // Если переходим на токой же URL
    // то обновляем страницу
    if ((current.fullPath || '0') === (route?.fullPath || '1')) {
      app.router.go();
    }

    // Если пути разные, то работет стандартная навигация
    // VUE route
    app.router.history.push({
      path: route.path,
      query: route.query,
      params: route.params,
      hash: route.hash,
    }, onComplete, onAbort);
  }
}
